var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessFood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-45 -60 208 213",
    width: 208,
    height: 213,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #161616;\n      }\n\n      .cls-2 {\n        fill: #6d6d6d;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #161616;\n        stroke-linecap: round;\n        strokeMiterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.8,58.87c-1.75-6.08-7.82-12.97-10.93-12.07-2.96.85-4.59,9.95-2.84,16.04,1.16,4.01,3.13,5.8,5.43,6.24,1.86.36,3.3,1.82,3.65,3.67l5.6,30.31c.22,1.17.92,2.19,1.93,2.82,1.01.62,2.24.8,3.38.47,1.14-.33,2.1-1.13,2.62-2.19.52-1.07.57-2.31.13-3.42l-11.37-28.65c-.7-1.76-.25-3.76,1.14-5.05,1.71-1.6,2.43-4.17,1.28-8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.31,18.68c-.56-.08-1.08.31-1.17.87l-1.83,12.53c-.08.56-.61.96-1.17.87s-.96-.61-.87-1.17l1.83-12.53c.08-.56-.31-1.08-.87-1.16h-.01c-.56-.08-1.08.3-1.16.87l-1.83,12.53c-.08.56-.61.96-1.17.87s-.96-.61-.87-1.17l1.83-12.53c.08-.56-.31-1.08-.87-1.16h-.01c-.56-.08-1.08.3-1.16.87l-1.83,12.53c-.08.56-.61.96-1.17.87s-.96-.61-.87-1.17l1.83-12.53c.08-.56-.31-1.08-.87-1.16s-1.03.29-1.11.82l-1.98,13.51c-.6,4.13.45,6.58,2.36,7.93,1.54,1.09,2.26,3.02,1.8,4.85l-7.42,29.92c-.29,1.15-.07,2.38.59,3.36.66.99,1.71,1.65,2.89,1.82s2.37-.16,3.29-.92c.92-.75,1.47-1.86,1.53-3.05l1.48-30.79c.09-1.89,1.33-3.53,3.12-4.13,2.22-.75,3.93-2.79,4.53-6.92.06-.42,1.51-10.34,1.98-13.51.08-.53-.29-1.03-.82-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.46,59c.12-.55-.23-1.1-.78-1.22-.44-.1-.89.1-1.11.49l-7.56,13.09c-2.37,4.1-2.5,9.12-.34,13.33.55,1.08.65,2.35.28,3.51l-8.13,25.03c-.37,1.13-.24,2.37.35,3.4.59,1.03,1.59,1.76,2.75,2.02,1.16.26,2.38,0,3.35-.68.97-.69,1.6-1.76,1.75-2.93l3.35-28.02,6.11-28.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.53 21.25 43.96 25.88 49.11 25.01 45.46 28.75 47.88 33.38 43.19 31.06 39.54 34.8 40.3 29.62 35.61 27.3 40.77 26.43 41.53 21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.62 93.45 65.05 98.09 70.21 97.21 66.55 100.95 68.98 105.59 64.29 103.26 60.63 107 61.39 101.83 56.7 99.5 61.86 98.63 62.62 93.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.4 50.38 9.83 55.02 14.99 54.14 11.33 57.88 13.76 62.52 9.07 60.19 5.41 63.93 6.17 58.76 1.48 56.43 6.64 55.56 7.4 50.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.63 20.76 98.51 25.87 103.02 28.52 97.82 29.03 96.69 34.14 94.6 29.35 89.39 29.86 93.3 26.38 91.21 21.59 95.72 24.24 99.63 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "105.78 91.8 105.64 97.03 110.58 98.77 105.56 100.26 105.43 105.5 102.46 101.19 97.45 102.68 100.63 98.52 97.66 94.21 102.59 95.95 105.78 91.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 35.33,
    x2: 12.1,
    y2: 38.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18,
    y1: 23.36,
    x2: 25.72,
    y2: 32.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.02,
    y1: 1,
    x2: 89.21,
    y2: 11.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.6,
    y1: 35.65,
    x2: 113.17,
    y2: 44.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 132.91,
    y1: 86.04,
    x2: 121.29,
    y2: 85.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.68,
    y1: 97.87,
    x2: 17.59,
    y2: 103.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.48,
    y1: 111.91,
    x2: 26.91,
    y2: 121.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.88,
    y1: 2.73,
    x2: 52.41,
    y2: 13.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.68,110.34c-.05.65-.27,1.27-.53,1.86-.61,1.38-1.54,2.76-2.97,3.2.74.65,1.49,1.31,2.23,1.96.19.17.41.35.67.35.2,0,.39-.11.56-.23,2.05-1.41,3.45-3.71,3.78-6.17.01-.09.02-.19-.01-.28-.04-.11-.15-.19-.26-.26-.89-.57-1.79-1.33-2.74-1.78-1.26-.59-.47.76-.72,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.85,45.78c.21.61.25,1.27.25,1.92,0,1.5-.31,3.15-1.46,4.12.94.3,1.88.61,2.83.91.24.08.52.16.75.06.19-.08.31-.26.42-.43,1.32-2.11,1.7-4.78,1.02-7.16-.03-.09-.06-.19-.12-.26-.09-.09-.22-.11-.34-.13-1.04-.18-2.17-.51-3.22-.54-1.39-.04-.13.89-.13,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.43,68.74c.21.61.25,1.27.25,1.92,0,1.5-.31,3.15-1.46,4.12.94.3,1.88.61,2.83.91.24.08.52.16.75.06.19-.08.31-.26.42-.43,1.32-2.11,1.7-4.78,1.02-7.16-.03-.09-.06-.19-.12-.26-.09-.09-.22-.11-.34-.13-1.04-.18-2.17-.51-3.22-.54-1.39-.04-.13.89-.13,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.62,79.52c-.71-.28-1.36-.73-1.97-1.21-1.42-1.11-2.79-2.54-3.02-4.16-.86.52-1.73,1.05-2.59,1.57-.22.14-.46.29-.51.55-.04.21.05.44.15.65,1.19,2.58,3.49,4.83,6.17,6.04.1.05.21.09.32.09.14,0,.24-.09.33-.17.8-.7,1.81-1.34,2.48-2.16.89-1.07-.76-.75-1.36-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m111.44,77.19c-.36-.67-.57-1.43-.73-2.19-.37-1.76-.49-3.74.39-5.13-1-.16-2-.32-2.99-.47-.26-.04-.54-.08-.75.09-.16.13-.24.37-.3.59-.76,2.74-.46,5.94.81,8.59.05.1.1.21.19.27.11.08.24.09.36.08,1.06-.01,2.25.14,3.29-.04,1.37-.24-.1-1.07-.26-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m61.95,118.36c-.71-.28-1.36-.73-1.97-1.21-1.42-1.11-2.79-2.54-3.02-4.16-.86.52-1.73,1.05-2.59,1.57-.22.14-.46.29-.51.55-.04.21.05.44.15.65,1.19,2.58,3.49,4.83,6.17,6.04.1.05.21.09.32.09.14,0,.24-.09.33-.17.8-.7,1.81-1.34,2.48-2.16.89-1.07-.76-.75-1.36-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.86,53.64c0,.83-.18,1.67-.39,2.48-.51,1.89-1.34,3.88-2.77,4.82.81.62,1.62,1.25,2.43,1.87.21.16.45.33.71.26.21-.05.39-.25.55-.44,1.97-2.32,3.22-5.59,3.36-8.77,0-.12,0-.25-.03-.35-.05-.13-.17-.2-.28-.25-.95-.49-1.93-1.19-2.94-1.5-1.33-.41-.42,1.09-.63,1.88Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFood);
export default __webpack_public_path__ + "static/media/success-food.1c14144596e80651d92d76953e6f1cb6.svg";
export { ForwardRef as ReactComponent };